import { ConfigService } from '@axo/config/ConfigService';
import { DropdownFieldUI } from '@axo/form/feature/form-input/DropdownField/DropdownFieldUI';
import { NumberFieldUI } from '@axo/form/feature/form-input/NumberField/NumberFieldUI';
import { useTranslation } from '@axo/shared/i18n';
import { useFormContext } from 'react-hook-form';
import { useBroker } from '../../../../../../../hooks/useBroker';
import { formatSpacedNumber } from '../../../../../../../utils/format';
import { HousingFormGroupData } from '../../../../../FormData.fi.types';
import { debtCreditorsOptions } from '../../../../config/globals';
import {
  housingDebtCreditorFieldOption,
  housingDebtMonthlyDebtPaymentFieldOption,
  housingDebtOutstandingAmountFieldOption,
} from './config';

export const HousingDebtFormGroup = () => {
  const { t } = useTranslation();

  const broker = useBroker();
  const { hasHousingDebtCreditor } = ConfigService.get('product-unsecured-loan')
    .fields[broker];

  const { watch } = useFormContext();
  const [maritalStatus, housingDebt] = watch([
    'LoanApplication/MaritalStatus',
    'Debt/Housing/OutstandingAmount',
  ]);

  const askHousingDebtCreditor = hasHousingDebtCreditor && housingDebt > 0;

  return (
    <>
      <NumberFieldUI<HousingFormGroupData>
        name="Debt/Housing/OutstandingAmount"
        label={t('Debt.Housing.OutstandingAmount.label', {
          context: maritalStatus,
        })}
        data-testid="debt-housing-outstanding-amount-input"
        format={formatSpacedNumber}
        suffix={t('suffix.currency')}
        {...housingDebtOutstandingAmountFieldOption}
      />

      {askHousingDebtCreditor && (
        <DropdownFieldUI<HousingFormGroupData>
          name="Debt/Housing/Creditor"
          label={t('Debt.Housing.Creditor.label')}
          data-testid="debt-housing-creditor-input"
          options={debtCreditorsOptions}
          {...housingDebtCreditorFieldOption}
        />
      )}

      {housingDebt > 0 && (
        <NumberFieldUI<HousingFormGroupData>
          name="Debt/Housing/MonthlyDebtPayment"
          label={t('Debt.Housing.MonthlyDebtPayment.label', {
            context: maritalStatus,
          })}
          data-testid="debt-housing-monthly-debt-payment-input"
          format={formatSpacedNumber}
          suffix={t('suffix.currency')}
          {...housingDebtMonthlyDebtPaymentFieldOption}
        />
      )}
    </>
  );
};
